<small *ngIf="show" class="unit-wrapper">
  /
  <span *ngIf="showQuantity">
    {{ quantity | number: '1.0-5' }}
  </span>
  {{ unit | tcUnitSymbol }}
</small>
